/**
 * Best-effort platform biometric name for CTA copy, or null when the platform
 * has no well-known label (Windows Hello and Android verify with varied
 * mechanisms, so those fall back to the generic product name).
 */
export const derivePlatformBiometricLabel = (): string | null => {
    if (typeof navigator === 'undefined') return null;
    const ua = navigator.userAgent;
    if (/iPhone|iPad/.test(ua)) return 'Face ID';
    if (/Mac/.test(ua)) return 'Touch ID';

    return null;
};
